import { PaginationModel } from "../../models/Pagination";


export const createPagination = (meta): PaginationModel => {
    return {
        totalCount: !!meta ? meta.page.totalRecords : 0,
        maxPageSize: !!meta ? meta.page.limit : 0,
        totalPages: !!meta ? meta.page.totalPages : 0,
        pageNumber: !!meta ? meta.page.number : 0
    };
};
